import type { Logger } from "@expert/logging";

import ky from "ky";

import type { DefaultPayload } from "./types";

import { defaultHeaders, defaultTimeoutInMS } from "../types";

type VerifyPasscodePayload = DefaultPayload & {
    transactionId: string;
    passcode: string;
};

interface VerifyPasscodeResult {
    deviceDescription: string;
    technologyType: string;
    zipCode: string;
    token: string;
}

export const verifyPasscode = async (
    ssoAccessToken: string,
    payload: VerifyPasscodePayload,
    verifyCustomerToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/verify-passcode`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, token: verifyCustomerToken },
            timeout: defaultTimeoutInMS,
        });

        const result = await resp.json<VerifyPasscodeResult>();
        return result;
    } catch (error) {
        logger.warn({ error }, `Error: Could not verify passcode.`);
        return { deviceDescription: undefined, technologyType: undefined, zipCode: undefined, token: undefined };
    }
};
